(function (window, document, $) {
	document.addEventListener('wpcf7submit', function (e) {
		if (e.detail.status && e.detail.status === "mail_sent") {
			const $formWrapper = $('.yco-contact__form__tab');
			$formWrapper.find('.wpcf7-contact-form').removeClass('active');
			$formWrapper.find('.wpcf7-contact-form').removeClass('in');
			$formWrapper.find('.wpcf7-thank-you').addClass('active');
			$formWrapper.find('.wpcf7-thank-you').addClass('in');
		}
	}, false);


	document.addEventListener( 'wpcf7invalid', function( event ) {
		setTimeout(function() {
			$('.wpcf7-response-output').fadeOut();
			console.log('ITT2')
		}, 7000);
	}, false );
	document.addEventListener( 'wpcf7spam', function( event ) {
		setTimeout(function() {
			$('.wpcf7-response-output').fadeOut();
			console.log('ITT2')
		}, 7000);
	}, false );
	document.addEventListener( 'wpcf7mailfailed', function( event ) {
		setTimeout(function() {
			$('.wpcf7-response-output').fadeOut();
			console.log('ITT2')
		}, 7000);
	}, false );
	document.addEventListener( 'wpcf7mailsent', function( event ) {
		setTimeout(function() {
			$('.wpcf7-response-output').fadeOut();
			console.log('ITT2')
		}, 7000);
	}, false );
})(window, document, jQuery);



// WEBPACK FOOTER //
// ./assets/scripts/contact.js